<template>
  <a-modal
    v-model="visible"
    class="home-CommonlyUsedSelect"
    centered
    :mask="false"
    :maskClosable="false"
    :bodyStyle="{
      height: '500px',
      padding: '16px',
    }"
    title="新增常用功能"
    :width="1000"
    :height="600"
    @ok="ok"
  >
<a-spin :spinning="loading">
    <a-row :gutter="8">
      <a-col :span="18" class="item item-left">
        <label class="item-title">待选功能</label>
        <div class="item-panel">
          <a-checkbox-group v-model="selected" style="display: block" @change="selectedChange">
            <a-collapse :activeKey="activeKey" :bordered="false">
              <a-collapse-panel
                v-for="(item, i) in list"
                :key="i"
                :header="item.name"
                forceRender
              >
                <a-row
                  v-for="(item2, i2) in item.child"
                  :key="i2"
                  class="menu-list"
                >
                  <a-col :span="5" :class="`item-level-${item2.level}`"> {{ item2.name }} </a-col>
                  <a-col :span="19" class="page-list">
                    <a-row>
                      <a-col
                        v-for="(item3, i3) in item2.child"
                        :key="i3"
                        :span="8"
                      >
                        <a-checkbox :value="item3.id">
                          {{ item3.name }}
                        </a-checkbox>
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
              </a-collapse-panel>
            </a-collapse>
          </a-checkbox-group>
        </div>
      </a-col>
      <a-col :span="6" class="item item-right">
        <div class="right-header">
          <label class="item-title">已选功能</label>
          <a @click="clearClick">清空</a>
        </div>
        <div class="item-panel">
          <a-tag v-for="item in selectList" :key="item.menuId" closable @close="removeClick($event, item)">{{item.menuName}}</a-tag>
        </div>
      </a-col>
    </a-row>
</a-spin>
  </a-modal>
</template>
<script>
import { getMenus, updateCommonFunctions } from '@/api/home'
export default {
  inject: ['confirm', 'toast'],
  data() {
    return {
      promise: {
        resolve: null,
        reject: null
      },
      loading: false,
      visible: false,
      activeKey: [0],
      selected: [],
      selectList: [],
      list: []
    }
  },
  watch: {
    visible (val) {
      if (val === false) {
        if (this.promise.resolve) {
          this.promise.reject()
        }
      }
    }
  },
  created() {
    getMenus().then(async (res) => {
      const { data } = await this.toast(res)
      this.list = data.map(({ subsystemName, levelMenuVoList }) => {
        const child = []
        this.foreach(child, levelMenuVoList, 0)
        return {
          name: subsystemName,
          child
        }
      })
    })
  },
  methods: {
    foreach(arr, list, level) {
      level += 1
      list.forEach(({ id, name, menuVoList, finalLevel }) => {
        if (!Array.isArray(menuVoList)) return
        if (finalLevel === 1) {
          arr.push({
            id,
            name,
            level,
            child: [
              {
                id,
                name
              }
            ]
          })
        } else {
          arr.push({
            id,
            name,
            level,
            child: menuVoList
              .filter((ele) => ele.finalLevel === 1)
              .map((ele) => {
                return {
                  id: ele.id,
                  name: ele.name
                }
              })
          })
          this.foreach(
            arr,
            menuVoList.filter((ele) => ele.finalLevel === 0),
            level
          )
        }
      })
    },
    show(resolve, reject, data) {
      this.promise.resolve = resolve
      this.promise.reject = reject
      this.selectList = JSON.parse(JSON.stringify(data))
      this.selected = this.selectList.map(ele => ele.menuId)
      this.visible = true
    },
    hide() {
      this.visible = false
    },
    selectedChange () {
      this.selectList = []
      this.list.forEach(({ child }) => {
        child.forEach(ele => {
          ele.child.forEach(({ id, name }) => {
            if (this.selected.includes(id)) {
              this.selectList.push({ menuId: id, menuName: name })
            }
          })
        })
      })
    },
    removeClick(e, { menuId }) {
      e.preventDefault()
      // 删除当前数据
      const listIndex = this.selectList.findIndex(ele => ele.menuId === menuId)
      this.selectList.splice(listIndex, 1)
      // 删除选中项
      const index = this.selected.indexOf(menuId)
      if (index >= 0) this.selected.splice(index, 1)
    },
    async ok() {
      if (this.loading) return
      // if (this.selected.length === 0) {
      //   return this.$message.error('请选择常用功能')
      // }
      this.loading = true
      try {
        const res = await updateCommonFunctions({
          ids: this.selected
        })
        await this.toast(res, 1)
        this.promise.resolve(res)
        this.promise.resolve = null
        this.hide()
      } catch (ex) {
        console.error(ex)
      }
      this.loading = false
    },
    async clearClick() {
      await this.confirm('确定清空全部已选功能？')
      this.selected = []
      this.selectList = []
    }
  }
}
</script>
<style lang="less" scoped>
.home-CommonlyUsedSelect {
  /deep/ .ant-modal-content {
    .item {
      .item-title {
        font-size: 14px;
        color: rgba(51, 51, 51, 0.85);
        font-weight: 500;
      }
      .item-panel {
        margin-top: 5px;
        border: 1px solid #e5e5e5;
        padding: 16px;
        overflow: auto;
        height: 444px;
      }
      &.item-left {
        .menu-list {
          font-size: 12px;
          .ant-checkbox-wrapper {
            font-size: 12px;
          }
          .item-level-2{
            text-indent: 10px;
          }
          .item-level-3{
            text-indent: 20px;
          }
          .item-level-4{
            text-indent: 30px;
          }
          .item-level-5{
            text-indent: 40px;
          }
          .item-level-6{
            text-indent: 50px;
          }
          .item-level-7{
            text-indent: 60px;
          }
        }
      }
      &.item-right {
        .right-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .item-panel {
          padding: 8px;
        }
        .ant-tag {
          padding: 5px 10px;
          border-radius: 15px;
          min-width: 150px;
          margin-bottom: 8px;
          display: inline-flex;
          justify-content: space-between;
          align-items: center;
          .anticon-close {
            color: #505050;
          }
        }
      }
    }
    .ant-collapse-item {
      border-bottom: 8px solid white;
      .ant-collapse-header {
        padding-left: 16px;
        .ant-collapse-arrow {
          position: absolute;
          right: 20px;
          width: 10px;
          left: auto;
          margin-top: -7px;
          transform: rotate(90deg);
          transform-origin: center;
        }
      }
      &.ant-collapse-item-active {
        .ant-collapse-header {
          .ant-collapse-arrow {
            transform: rotate(180deg);
          }
        }
      }
      .ant-collapse-content {
        background: white;
        .ant-collapse-content-box {
          padding: 0;
        }
        .menu-list {
          background: #f7f8fb;
          & > .ant-col {
            padding: 10px 16px;
            &:nth-child(2) {
              padding: 0 30px;
            }
          }
          .page-list {
            background: white;
            border-bottom: 1px solid rgba(159, 162, 169, 0.1);
            .ant-col {
              padding: 10px;
            }
          }
        }
      }
    }
    .ant-modal-footer {
      button:nth-child(1) {
        float: right;
        margin-left: 8px;
      }
    }
  }
}
</style>
